<ng-template #tile>
  <article class="ui-article" [attr.data-article]="datakey">
    <ng-content></ng-content>
  </article>
</ng-template>
